import { WindowService } from './../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../app/services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { LicenseManager } from '../../managers/License.manager';
import { SortBot } from '../../helpers/sort';
import { CPUBenchmarkItemArray } from '@models/domain/cpu.benchmark.item';
import { GetBenchmarksRequest } from '@models/ss-api/requests/get.benchmarks.request';
import { UpdateCPUBenchmarkDialog } from 'app/dialogs/update.cpubenchmark/update.cpubenchmark.dialog';

@Component({
    selector: 'update-cpubenchmarks',
    templateUrl: './update.cpubenchmarks.component.html',
    styleUrls: ['./update.cpubenchmarks.component.scss']
})

export class UpdateCPUBenchmarksComponent implements OnInit {
    IsBusy: boolean = false;

    CPUBenchmarks: CPUBenchmarkItemArray;
    CPUBenchmarksFilter: string;

    UnknownOnly: boolean = false;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('CPU Benchmarks');
        // this.IsBusy = true;
        this.LoadCPUBenchmarks();
    }

    BenchmarkSite(){
        let newTab = window.open();

        newTab.location.href = 'https://www.cpubenchmark.net/cpu_list.php';
    }

    MegaList(){
        let newTab = window.open();

        newTab.location.href = 'https://www.cpubenchmark.net/CPU_mega_page.html';
    }


    paginateBenchmarks(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }
 

    LoadCPUBenchmarks() {
        this.IsBusy = true;

        var request = new GetBenchmarksRequest();
        request.IncludeCPUs = true;
        request.IncludeVideoCards = false;
        request.MissingValuesOnly = this.UnknownOnly;

        let disposable = this.api.GetBenchmarks(request).subscribe(response => {
            this.IsBusy = false;
            this.CPUBenchmarks = response.Data.CPUBenchmarkItems;
            console.log("cbm", this.CPUBenchmarks);
            disposable.unsubscribe();
        });
    }

    AddCPUBenchmark() {
        let disposable = this.dialogService.addDialog(UpdateCPUBenchmarkDialog, {
            Title: 'Add CPU Benchmark'
        }, { width: 600, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadCPUBenchmarks();
            }
        });
    }

    EditCPUBenchmark(cpuBenchmark) {
        let disposable = this.dialogService.addDialog(UpdateCPUBenchmarkDialog, {
            Title: 'Edit CPU Benchmark',
            CPUBenchmark: cpuBenchmark
            //CPUBenchmarkItem: cpuBenchmark
        }, { width: 600, height: 650 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadCPUBenchmarks();
            }
        });
    }

   
    ToggleUnknownOnly() {
        this.UnknownOnly = !this.UnknownOnly;
        this.LoadCPUBenchmarks();
    } 

    SortBy( sortVar1: string, sortVar2: string = '' ) {
        this.CPUBenchmarks = SortBot.SortAuto( this.CPUBenchmarks, sortVar1, sortVar2);
    }

    onSearchTable(term) {
        this.CPUBenchmarksFilter = term;
    }

}
